import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "cdes-page" }
const _hoisted_2 = { class: "pageCaption" }
const _hoisted_3 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_4 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = ["id", "data-bs-target", "aria-controls"]
const _hoisted_6 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_7 = ["id", "data-bs-target", "aria-controls"]
const _hoisted_8 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_9 = ["id", "data-bs-target", "aria-controls"]
const _hoisted_10 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_11 = ["id", "data-bs-target", "aria-controls"]
const _hoisted_12 = { class: "tab-content" }
const _hoisted_13 = ["id", "aria-labelledby"]
const _hoisted_14 = ["for"]
const _hoisted_15 = ["id", "value"]
const _hoisted_16 = ["for"]
const _hoisted_17 = ["id", "maxlength", "disabled"]
const _hoisted_18 = ["for"]
const _hoisted_19 = ["id", "disabled"]
const _hoisted_20 = { class: "invalid-feedback" }
const _hoisted_21 = ["for"]
const _hoisted_22 = ["id", "disabled"]
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id", "disabled"]
const _hoisted_25 = { class: "invalid-feedback" }
const _hoisted_26 = ["for"]
const _hoisted_27 = ["id", "disabled"]
const _hoisted_28 = ["for"]
const _hoisted_29 = ["id", "disabled"]
const _hoisted_30 = { class: "invalid-feedback" }
const _hoisted_31 = ["for"]
const _hoisted_32 = ["id", "disabled"]
const _hoisted_33 = { class: "invalid-feedback" }
const _hoisted_34 = ["for"]
const _hoisted_35 = ["id", "disabled"]
const _hoisted_36 = { class: "invalid-feedback" }
const _hoisted_37 = { class: "invalid-feedback" }
const _hoisted_38 = { class: "col-form-label col-md-12-em" }
const _hoisted_39 = ["id"]
const _hoisted_40 = ["id", "aria-labelledby"]
const _hoisted_41 = { class: "row g-3 px-3 pt-3" }
const _hoisted_42 = { class: "form-check col-12" }
const _hoisted_43 = ["id", "disabled"]
const _hoisted_44 = ["for"]
const _hoisted_45 = { class: "form-check col-12" }
const _hoisted_46 = ["id", "disabled"]
const _hoisted_47 = ["for"]
const _hoisted_48 = { class: "form-check col-12" }
const _hoisted_49 = ["id", "disabled"]
const _hoisted_50 = ["for"]
const _hoisted_51 = { class: "table-responsive" }
const _hoisted_52 = { class: "table projectEditWidgetHolidayTable" }
const _hoisted_53 = ["id"]
const _hoisted_54 = ["id"]
const _hoisted_55 = ["id"]
const _hoisted_56 = ["id"]
const _hoisted_57 = ["aria-labelledby", "onUpdate:modelValue"]
const _hoisted_58 = { class: "invalid-feedback" }
const _hoisted_59 = { class: "invalid-feedback" }
const _hoisted_60 = { class: "invalid-feedback" }
const _hoisted_61 = ["aria-labelledby", "title", "onClick"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = { ref: "addRow" }
const _hoisted_65 = ["aria-labelledby", "id", "disabled"]
const _hoisted_66 = { class: "invalid-feedback" }
const _hoisted_67 = { class: "invalid-feedback" }
const _hoisted_68 = { class: "invalid-feedback" }
const _hoisted_69 = ["title", "aria-label", "id", "disabled"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = ["id", "aria-labelledby"]
const _hoisted_73 = { class: "row g-3 px-3 pt-3" }
const _hoisted_74 = { legend: "$t('project.edit.realms.tabCaption')" }
const _hoisted_75 = { class: "table-responsive" }
const _hoisted_76 = { class: "table projectEditRealmTable" }
const _hoisted_77 = ["id"]
const _hoisted_78 = ["id"]
const _hoisted_79 = ["id"]
const _hoisted_80 = ["id"]
const _hoisted_81 = ["id"]
const _hoisted_82 = ["id"]
const _hoisted_83 = ["id"]
const _hoisted_84 = ["id"]
const _hoisted_85 = ["aria-labelledby", "onUpdate:modelValue", "disabled"]
const _hoisted_86 = { class: "invalid-feedback" }
const _hoisted_87 = ["aria-labelledby", "onUpdate:modelValue", "disabled"]
const _hoisted_88 = { class: "invalid-feedback" }
const _hoisted_89 = ["aria-labelledby", "onUpdate:modelValue", "disabled"]
const _hoisted_90 = ["aria-labelledby", "onUpdate:modelValue", "disabled"]
const _hoisted_91 = ["aria-labelledby", "onUpdate:modelValue", "disabled"]
const _hoisted_92 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_93 = ["aria-labelledby", "onUpdate:modelValue", "disabled"]
const _hoisted_94 = { key: 0 }
const _hoisted_95 = ["aria-labelledby", "title", "onClick", "disabled"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = { ref: "addRow" }
const _hoisted_99 = ["aria-labelledby", "id", "disabled"]
const _hoisted_100 = { class: "invalid-feedback" }
const _hoisted_101 = ["aria-labelledby", "id", "disabled"]
const _hoisted_102 = { class: "invalid-feedback" }
const _hoisted_103 = ["aria-labelledby", "id", "disabled"]
const _hoisted_104 = ["aria-labelledby", "id", "disabled"]
const _hoisted_105 = ["aria-labelledby", "id", "disabled"]
const _hoisted_106 = ["aria-labelledby", "id", "disabled"]
const _hoisted_107 = ["aria-labelledby", "id", "disabled"]
const _hoisted_108 = { key: 0 }
const _hoisted_109 = ["title", "aria-label", "id", "disabled"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = ["id", "aria-labelledby"]
const _hoisted_113 = ["for"]
const _hoisted_114 = ["id"]
const _hoisted_115 = ["title"]
const _hoisted_116 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = {
  key: 0,
  class: "countLabel"
}
const _hoisted_119 = { class: "row g-3 pt-3 px-3" }
const _hoisted_120 = { class: "col-auto" }
const _hoisted_121 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormGridMember = _resolveComponent("FormGridMember")!
  const _component_Transform = _resolveComponent("Transform")!
  const _component_FormGridColumn = _resolveComponent("FormGridColumn")!
  const _component_Label = _resolveComponent("Label")!
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_FormGridLocal = _resolveComponent("FormGridLocal")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ObjectPlannerPositionDefinitionListWidget = _resolveComponent("ObjectPlannerPositionDefinitionListWidget")!

  return (_openBlock(), _createBlock(_component_Transform, { transformer: _ctx.formTransformer }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, [
          (_ctx.isNew)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('project.edit.newHeading')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('project.edit.editHeading')), 1)
              ], 64))
        ]),
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("button", {
              class: "nav-link active",
              role: "tab",
              id: _ctx.$id('project-tab'),
              "data-bs-toggle": "tab",
              type: "button",
              "data-bs-target": '#' + _ctx.$id('project'),
              "aria-controls": _ctx.$id('project'),
              "aria-selected": "true"
            }, _toDisplayString(_ctx.$t('general.project')), 9, _hoisted_5)
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("button", {
              class: "nav-link",
              role: "tab",
              id: _ctx.$id('options-tab'),
              "data-bs-toggle": "tab",
              type: "button",
              "data-bs-target": '#' + _ctx.$id('options'),
              "aria-controls": _ctx.$id('options'),
              "aria-selected": "false"
            }, _toDisplayString(_ctx.$t('general.options')), 9, _hoisted_7)
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("button", {
              class: "nav-link",
              role: "tab",
              id: _ctx.$id('realms-tab'),
              "data-bs-toggle": "tab",
              type: "button",
              "data-bs-target": '#' + _ctx.$id('realms'),
              "aria-controls": _ctx.$id('realms'),
              "aria-selected": "false"
            }, _toDisplayString(_ctx.$t('project.edit.realms.tabCaption')), 9, _hoisted_9)
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("button", {
              class: "nav-link",
              role: "tab",
              id: _ctx.$id('object-planner-definitions-tab'),
              "data-bs-toggle": "tab",
              type: "button",
              "data-bs-target": '#' + _ctx.$id('objectPlannerDefinitions'),
              "aria-controls": _ctx.$id('objectPlannerDefinitions'),
              "aria-selected": "false"
            }, _toDisplayString(_ctx.$t('project.edit.objectPlannerDefinitions.tabCaption')), 9, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "tab-pane show active",
            id: _ctx.$id('project'),
            role: "tabpanel",
            "aria-labelledby": _ctx.$id('project-tab')
          }, [
            _createVNode(_component_FormGridLocal, {
              columns: 2,
              labelWidth: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'row': true, 'g-3': true, 'px-3': true, 'pt-3': true, 'was-validated': _ctx.wasValidated })
                }, [
                  _createVNode(_component_FormGridColumn, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createElementVNode("label", {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, _toDisplayString(_ctx.$t('general.network')), 11, _hoisted_14)
                        ]),
                        control: _withCtx(({ id }) => [
                          _createElementVNode("input", {
                            type: "text",
                            id: id,
                            class: "form-control",
                            maxlength: "10",
                            disabled: "false",
                            value: this.projectPageInfo != null && this.projectPageInfo.network != null ? this.projectPageInfo.network.name : ''
                          }, null, 8, _hoisted_15)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createElementVNode("label", {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, _toDisplayString(_ctx.$t('general.project')), 11, _hoisted_16)
                        ]),
                        control: _withCtx(({ id }) => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: id,
                            class: _normalizeClass(["form-control", this.codeFeedbackClass]),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.project.code) = $event)),
                            maxlength: _ctx.maxProjectCodeLengthPartGroup,
                            disabled: !this.initialized || this.projectPageInfo == null || this.projectPageInfo.hasExistingDocuments,
                            required: "",
                            ref: "codeInput"
                          }, null, 10, _hoisted_17), [
                            [_vModelText, this.project.code]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["projectCodeFeedback invalid-feedback", this.invalidClass])
                          }, [
                            (_ctx.isCodeDuplicate)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('project.edit.duplicateCode')), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('project.edit.missingCode')), 1)
                                ], 64))
                          ], 2)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createElementVNode("label", {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, _toDisplayString(_ctx.$t('project.edit.nameLabel')), 11, _hoisted_18)
                        ]),
                        control: _withCtx(({ id }) => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: id,
                            class: _normalizeClass(["form-control", this.nameFeedbackClass]),
                            maxlength: "80",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.project.name) = $event)),
                            disabled: !this.initialized,
                            required: ""
                          }, null, 10, _hoisted_19), [
                            [_vModelText, this.project.name]
                          ]),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('project.edit.missingName')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createElementVNode("label", {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, _toDisplayString(_ctx.$t('project.edit.principalProject')), 11, _hoisted_21)
                        ]),
                        control: _withCtx(({ id }) => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: id,
                            class: "form-control",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.project.principalProject) = $event)),
                            disabled: !this.initialized,
                            maxlength: "80"
                          }, null, 8, _hoisted_22), [
                            [_vModelText, this.project.principalProject]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createElementVNode("label", {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, _toDisplayString(_ctx.$t('project.edit.route')), 11, _hoisted_23)
                        ]),
                        control: _withCtx(({ id }) => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: id,
                            class: "form-control",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.project.routeName) = $event)),
                            maxlength: "100",
                            disabled: !this.initialized
                          }, null, 8, _hoisted_24), [
                            [_vModelText, this.project.routeName]
                          ]),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('project.edit.missingRoute')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createElementVNode("label", {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, _toDisplayString(_ctx.$t('project.edit.stretch')), 11, _hoisted_26)
                        ]),
                        control: _withCtx(({ id }) => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: id,
                            class: "form-control",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.project.stretchName) = $event)),
                            disabled: !this.initialized,
                            maxlength: "100"
                          }, null, 8, _hoisted_27), [
                            [_vModelText, this.project.stretchName]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createElementVNode("label", {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, _toDisplayString(_ctx.$t('project.edit.from')), 11, _hoisted_28)
                        ]),
                        control: _withCtx(({ id }) => [
                          _createVNode(_component_Transform, { transformer: _ctx.fromKmTransformer }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                id: id,
                                step: "0.001",
                                class: _normalizeClass(["form-control", this.stretchKmFromFeedbackClass]),
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.project.stretchKmFrom) = $event)),
                                onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fromKmOnInput && _ctx.fromKmOnInput(...args))),
                                disabled: !this.initialized,
                                required: "",
                                ref: "fromKmRef"
                              }, null, 42, _hoisted_29), [
                                [_vModelText, this.project.stretchKmFrom]
                              ])
                            ]),
                            _: 2
                          }, 1032, ["transformer"]),
                          _createElementVNode("div", _hoisted_30, [
                            (_ctx.fromKmValidity.badInput)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('project.edit.badInputFrom')), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('project.edit.missingFrom')), 1)
                                ], 64))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createElementVNode("label", {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, _toDisplayString(_ctx.$t('project.edit.to')), 11, _hoisted_31)
                        ]),
                        control: _withCtx(({ id }) => [
                          _createVNode(_component_Transform, { transformer: _ctx.toKmTransformer }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                id: id,
                                step: "0.001",
                                class: _normalizeClass(["form-control", this.stretchKmToFeedbackClass]),
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.project.stretchKmTo) = $event)),
                                onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toKmOnInput && _ctx.toKmOnInput(...args))),
                                disabled: !this.initialized,
                                required: "",
                                ref: "toKmRef"
                              }, null, 42, _hoisted_32), [
                                [_vModelText, this.project.stretchKmTo]
                              ])
                            ]),
                            _: 2
                          }, 1032, ["transformer"]),
                          _createElementVNode("div", _hoisted_33, [
                            (_ctx.toKmValidity.badInput)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('project.edit.badInputTo')), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('project.edit.missingTo')), 1)
                                ], 64))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormGridColumn, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createElementVNode("label", {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, _toDisplayString(_ctx.$t('general.comment')), 11, _hoisted_34)
                        ]),
                        control: _withCtx(({ id }) => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: id,
                            class: "form-control",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.project.comment) = $event)),
                            disabled: !this.initialized,
                            maxlength: "255"
                          }, null, 8, _hoisted_35), [
                            [_vModelText, this.project.comment]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createVNode(_component_Label, {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('project.edit.localisation')), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "for"])
                        ]),
                        control: _withCtx(({ id }) => [
                          _createVNode(_component_CustomSelect, {
                            type: "text",
                            id: id,
                            options: this.localisations,
                            optionValue: a => a.id,
                            optionLabel: a => a.name,
                            disabled: !this.initialized,
                            class: _normalizeClass(this.localisationIdFeedbackClass),
                            modelValue: this.project.localisationId,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((this.project.localisationId) = $event)),
                            wasValidated: _ctx.wasValidated,
                            required: ""
                          }, null, 8, ["id", "options", "optionValue", "optionLabel", "disabled", "class", "modelValue", "wasValidated"]),
                          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('project.edit.missingLocalisation')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormGridMember, null, {
                        label: _withCtx(({ controlId, class: clazz }) => [
                          _createVNode(_component_Label, {
                            class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                            for: controlId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('project.edit.documentNumberPartGroups')), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "for"])
                        ]),
                        control: _withCtx(({ id }) => [
                          _createVNode(_component_CustomSelect, {
                            type: "text",
                            id: id,
                            options: this.documentNumberPartGroups,
                            optionValue: a => a.id,
                            optionLabel: a => a.name,
                            disabled: !this.initialized || _ctx.hasExistingDocuments,
                            class: _normalizeClass(this.documentNumberPartGroupIdFeedbackClass),
                            modelValue: this.project.documentNumberPartGroupId,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.project.documentNumberPartGroupId) = $event)),
                            wasValidated: _ctx.wasValidated,
                            required: ""
                          }, null, 8, ["id", "options", "optionValue", "optionLabel", "disabled", "class", "modelValue", "wasValidated"]),
                          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('project.edit.missingdocumentNumberPartGroups')), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.isNew)
                        ? (_openBlock(), _createBlock(_component_FormGridMember, { key: 0 }, {
                            label: _withCtx(({ controlId, class: clazz }) => [
                              _createVNode(_component_Label, {
                                class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                                for: controlId
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('general.projectLeader')), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "for"])
                            ]),
                            control: _withCtx(({ id }) => [
                              _createVNode(_component_CustomSelect, {
                                ref: "projectLeaderSelect",
                                type: "text",
                                id: id,
                                options: this.organisationPersonSelectionJoins,
                                optionValue: a => a.organisationPersonId,
                                optionLabel: selectionJoin => this.renderProjectLeader(selectionJoin),
                                disabled: !this.initialized,
                                modelValue: this.projectLeaderId,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.projectLeaderId) = $event)),
                                defaultValue: this.ctx.activeOrganisationPersonId,
                                wasValidated: _ctx.wasValidated,
                                optional: true,
                                optionalLabel: _ctx.$t('general.none'),
                                sort: ""
                              }, null, 8, ["id", "options", "optionValue", "optionLabel", "disabled", "modelValue", "defaultValue", "wasValidated", "optionalLabel"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isNew)
                        ? (_openBlock(), _createBlock(_component_FormGridMember, { key: 1 }, {
                            label: _withCtx(({ controlId, class: clazz }) => [
                              _createVNode(_component_Label, {
                                class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                                for: controlId
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('project.edit.createdTime')), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "for"])
                            ]),
                            control: _withCtx(({ }) => [
                              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$d(new Date(this.createdTime * 1000), { dateStyle: 'short' })), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isNew)
                        ? (_openBlock(), _createBlock(_component_FormGridMember, { key: 2 }, {
                            label: _withCtx(({ controlId, class: clazz }) => [
                              _createVNode(_component_Label, {
                                class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                                for: controlId
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('project.edit.createdBy')), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "for"])
                            ]),
                            control: _withCtx(({ id }) => [
                              _createElementVNode("div", {
                                class: "form-control-plaintext",
                                id: id
                              }, _toDisplayString(this.createdByPerson.givenName) + " " + _toDisplayString(this.createdByPerson.surName), 9, _hoisted_39)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ], 2)
              ]),
              _: 1
            })
          ], 8, _hoisted_13),
          _createElementVNode("div", {
            class: "tab-pane",
            id: _ctx.$id('options'),
            role: "tabpanel",
            "aria-labelledby": _ctx.$id('options-tab')
          }, [
            _createVNode(_component_FormGridLocal, {
              columns: 1,
              labelWidth: 11
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: _ctx.$id('option1'),
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((this.project.ignorePlotOrderReceivedSteps) = $event)),
                          disabled: !this.initialized
                        }, null, 8, _hoisted_43), [
                          [_vModelCheckbox, this.project.ignorePlotOrderReceivedSteps]
                        ]),
                        _createElementVNode("label", {
                          for: _ctx.$id('option1')
                        }, _toDisplayString(_ctx.$t('project.edit.ignorePlotOrderReceivedSteps')), 9, _hoisted_44)
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
                    }, [
                      _createElementVNode("div", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: _ctx.$id('option2'),
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((this.project.withParticipantsSubProjectRestriction) = $event)),
                          disabled: !this.initialized
                        }, null, 8, _hoisted_46), [
                          [_vModelCheckbox, this.project.withParticipantsSubProjectRestriction]
                        ]),
                        _createElementVNode("label", {
                          for: _ctx.$id('option2')
                        }, _toDisplayString(_ctx.$t('project.edit.withParticipantsSubProjectRestriction')), 9, _hoisted_47)
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
                    }, [
                      _createElementVNode("div", _hoisted_48, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: _ctx.$id('option3'),
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((this.project.objectCodeWithObjectTypeOnly) = $event)),
                          disabled: !this.initialized
                        }, null, 8, _hoisted_49), [
                          [_vModelCheckbox, this.project.objectCodeWithObjectTypeOnly]
                        ]),
                        _createElementVNode("label", {
                          for: _ctx.$id('option3')
                        }, _toDisplayString(_ctx.$t('project.edit.objectCodeWithObjectTypeOnly')), 9, _hoisted_50)
                      ])
                    ], 2),
                    _createVNode(_component_FormGridMember, {
                      class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
                    }, {
                      label: _withCtx(({ controlId, class: clazz }) => [
                        _createVNode(_component_Label, {
                          class: _normalizeClass(`col-form-label ${clazz}`),
                          for: controlId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('project.edit.allowedResultOption')), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "for"])
                      ]),
                      control: _withCtx(({ id }) => [
                        _createVNode(_component_CustomSelect, {
                          type: "text",
                          id: id,
                          options: this.reviewCycleResultOptions,
                          optionValue: a => a.id,
                          optionLabel: a => _ctx.$s(a.name),
                          modelValue: this.project.allowedResultOptionId,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((this.project.allowedResultOptionId) = $event)),
                          optional: "",
                          optionalLabel: _ctx.$t('general.none'),
                          disabled: !this.initialized
                        }, null, 8, ["id", "options", "optionValue", "optionLabel", "modelValue", "optionalLabel", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("fieldset", null, [
                      _createElementVNode("legend", null, _toDisplayString(_ctx.$t('general.projectHolidays')), 1),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("table", _hoisted_52, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", {
                                id: _ctx.$id('name')
                              }, _toDisplayString(_ctx.$t('general.name')), 9, _hoisted_53),
                              _createElementVNode("th", {
                                id: _ctx.$id('from')
                              }, _toDisplayString(_ctx.$t('general.from')), 9, _hoisted_54),
                              _createElementVNode("th", {
                                id: _ctx.$id('to')
                              }, _toDisplayString(_ctx.$t('general.to')), 9, _hoisted_55),
                              _createElementVNode("th", {
                                id: _ctx.$id('action')
                              }, _toDisplayString(_ctx.$t('general.column.actions')), 9, _hoisted_56)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.projectHolidays, (holiday, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: holiday?.id ?? holiday.name,
                                class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
                              }, [
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["form-control", holiday.description && holiday.description.length > 0? '' : 'mustField']),
                                    "aria-labelledby": _ctx.$id('name'),
                                    "onUpdate:modelValue": ($event: any) => ((holiday.description) = $event),
                                    required: ""
                                  }, null, 10, _hoisted_57), [
                                    [_vModelText, holiday.description]
                                  ]),
                                  _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('project.edit.projectHolidays.missingName')), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_DateInput, {
                                    "aria-labelledby": _ctx.$id('from'),
                                    utcSeconds: holiday.startDate,
                                    "onUpdate:utcSeconds": ($event: any) => ((holiday.startDate) = $event),
                                    class: _normalizeClass(holiday.startDate && holiday.startDate != null ? '' : 'mustField'),
                                    required: ""
                                  }, null, 8, ["aria-labelledby", "utcSeconds", "onUpdate:utcSeconds", "class"]),
                                  _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('project.edit.projectHolidays.missingFrom')), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_DateInput, {
                                    "aria-labelledby": _ctx.$id('to'),
                                    utcSeconds: holiday.endDate,
                                    "onUpdate:utcSeconds": ($event: any) => ((holiday.endDate) = $event),
                                    class: _normalizeClass(holiday.endDate && holiday.endDate != null ? '' : 'mustField'),
                                    required: ""
                                  }, null, 8, ["aria-labelledby", "utcSeconds", "onUpdate:utcSeconds", "class"]),
                                  _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('project.edit.projectHolidays.missingTo')), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-danger",
                                    "aria-labelledby": _ctx.$id('action'),
                                    title: _ctx.$t('general.delete'),
                                    onClick: ($event: any) => (_ctx.deleteHoliday(holiday, index))
                                  }, _hoisted_63, 8, _hoisted_61)
                                ])
                              ], 2))
                            }), 128)),
                            _createElementVNode("tr", _hoisted_64, [
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["form-control", !this.initialiezd?'hidden':'']),
                                  "aria-labelledby": _ctx.$id('name'),
                                  id: _ctx.$id('temporaryHolidayName'),
                                  required: "",
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.temporaryHolidayName) = $event)),
                                  ref: "temporaryHolidayNameRef",
                                  disabled: !this.initialiezd
                                }, null, 10, _hoisted_65), [
                                  [_vModelText, _ctx.temporaryHolidayName]
                                ]),
                                _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('project.edit.projectHolidays.missingName')), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_DateInput, {
                                  "aria-labelledby": _ctx.$id('from'),
                                  required: "",
                                  utcSeconds: _ctx.temporaryHolidayStartDate,
                                  "onUpdate:utcSeconds": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.temporaryHolidayStartDate) = $event)),
                                  id: _ctx.$id('temporaryHolidayStartDate'),
                                  ref: "temporaryHolidayStartDateRef",
                                  disabled: _ctx.info === _ctx.loadingPlaceholder,
                                  class: _normalizeClass(!this.initialiezd?'hidden':'')
                                }, null, 8, ["aria-labelledby", "utcSeconds", "id", "disabled", "class"]),
                                _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t('project.edit.projectHolidays.missingFrom')), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_DateInput, {
                                  "aria-labelledby": _ctx.$id('to'),
                                  required: "",
                                  utcSeconds: _ctx.temporaryHolidayEndDate,
                                  "onUpdate:utcSeconds": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.temporaryHolidayEndDate) = $event)),
                                  id: _ctx.$id('temporaryHolidayEndDate'),
                                  ref: "temporaryHolidayEndDateRef",
                                  disabled: _ctx.info === _ctx.loadingPlaceholder,
                                  class: _normalizeClass(!this.initialiezd?'hidden':'')
                                }, null, 8, ["aria-labelledby", "utcSeconds", "id", "disabled", "class"]),
                                _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('project.edit.projectHolidays.missingTo')), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-primary",
                                  title: _ctx.$t('general.add'),
                                  "aria-label": _ctx.$t('general.add'),
                                  id: _ctx.$id('temporaryHolidaySubmit'),
                                  disabled: !this.initialized,
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.addHoliday()))
                                }, _hoisted_71, 8, _hoisted_69)
                              ])
                            ], 512)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ], 8, _hoisted_40),
          _createElementVNode("div", {
            class: "tab-pane",
            id: _ctx.$id('realms'),
            role: "tabpanel",
            "aria-labelledby": _ctx.$id('realms-tab')
          }, [
            _createVNode(_component_FormGridLocal, {
              columns: 1,
              labelWidth: 11
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_73, [
                    _createVNode(_component_FormGridMember, {
                      class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
                    }, {
                      control: _withCtx(({ }) => [
                        _createVNode(_component_Select, {
                          label: _ctx.$t("project.edit.realms.reviewCycleSelect"),
                          id: _ctx.$id('reviewCycleSelect'),
                          options: this.reviewCycleSelectOptions,
                          modelValue: _ctx.reviewCycleId,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.reviewCycleId) = $event)),
                          selectClass: this.reviewCycleCss
                        }, null, 8, ["label", "id", "options", "modelValue", "selectClass"]),
                        _createVNode(_component_Select, {
                          label: _ctx.$t("project.edit.realms.reviewCycleNodeSelect"),
                          id: _ctx.$id('positionTypeSelect'),
                          options: this.positionTypeSelectOptions,
                          modelValue: _ctx.positionTypeId,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.positionTypeId) = $event)),
                          selectClass: this.positionTypeCss
                        }, null, 8, ["label", "id", "options", "modelValue", "selectClass"])
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("fieldset", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("table", _hoisted_76, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", {
                                id: _ctx.$id('code')
                              }, _toDisplayString(_ctx.$t('project.edit.realms.code')), 9, _hoisted_77),
                              _createElementVNode("th", {
                                id: _ctx.$id('name')
                              }, _toDisplayString(_ctx.$t('project.edit.realms.name')), 9, _hoisted_78),
                              _createElementVNode("th", {
                                id: _ctx.$id('description')
                              }, _toDisplayString(_ctx.$t('project.edit.realms.description')), 9, _hoisted_79),
                              _createElementVNode("th", {
                                id: _ctx.$id('labelText')
                              }, _toDisplayString(_ctx.$t('project.edit.realms.labelText')), 9, _hoisted_80),
                              _createElementVNode("th", {
                                id: _ctx.$id('redliningColor')
                              }, _toDisplayString(_ctx.$t('project.edit.realms.redliningColor')), 9, _hoisted_81),
                              _createElementVNode("th", {
                                id: _ctx.$id('signatureOnLabel')
                              }, _toDisplayString(_ctx.$t('project.edit.realms.signatureOnLabel')), 9, _hoisted_82),
                              _createElementVNode("th", {
                                id: _ctx.$id('labelTextFieldSeq')
                              }, _toDisplayString(_ctx.$t('project.edit.realms.labelTextFieldSeq')), 9, _hoisted_83),
                              _createElementVNode("th", {
                                id: _ctx.$id('action')
                              }, _toDisplayString(_ctx.$t('general.column.actions')), 9, _hoisted_84)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.realms, (realm, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: realm.id?realm.id:realm.idx,
                                class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
                              }, [
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "aria-labelledby": _ctx.$id('code'),
                                    "onUpdate:modelValue": ($event: any) => ((realm.code) = $event),
                                    maxlength: "10",
                                    disabled: !this.mayEditRealms
                                  }, null, 8, _hoisted_85), [
                                    [_vModelText, realm.code]
                                  ]),
                                  _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.$t('project.edit.realms.missingCode')), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["form-control", realm.name.length > 0? '' : 'mustField']),
                                    "aria-labelledby": _ctx.$id('name'),
                                    "onUpdate:modelValue": ($event: any) => ((realm.name) = $event),
                                    maxlength: "80",
                                    required: "",
                                    disabled: !this.mayEditRealms
                                  }, null, 10, _hoisted_87), [
                                    [_vModelText, realm.name]
                                  ]),
                                  _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.$t('project.edit.realms.missingName')), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "aria-labelledby": _ctx.$id('description'),
                                    "onUpdate:modelValue": ($event: any) => ((realm.description) = $event),
                                    disabled: !this.mayEditRealms
                                  }, null, 8, _hoisted_89), [
                                    [_vModelText, realm.description]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "aria-labelledby": _ctx.$id('labelText'),
                                    "onUpdate:modelValue": ($event: any) => ((realm.labelText) = $event),
                                    disabled: !this.mayEditRealms
                                  }, null, 8, _hoisted_90), [
                                    [_vModelText, realm.labelText]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "color",
                                    class: "form-control",
                                    "aria-labelledby": _ctx.$id('redliningColor'),
                                    "onUpdate:modelValue": ($event: any) => ((realm.redliningColor) = $event),
                                    disabled: !this.mayEditRealms
                                  }, null, 8, _hoisted_91), [
                                    [_vModelText, realm.redliningColor]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: _ctx.$id('signatureOnLabel'),
                                    "onUpdate:modelValue": ($event: any) => ((realm.signatureOnLabel) = $event),
                                    disabled: !this.mayEditRealms || !this.initialized
                                  }, null, 8, _hoisted_92), [
                                    [_vModelCheckbox, realm.signatureOnLabel]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "aria-labelledby": _ctx.$id('labelTextFieldSeq'),
                                    "onUpdate:modelValue": ($event: any) => ((realm.labelTextFieldSeq) = $event),
                                    maxlength: "1",
                                    disabled: !this.mayEditRealms
                                  }, null, 8, _hoisted_93), [
                                    [_vModelText, realm.labelTextFieldSeq]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  (this.mayEditRealms)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-sm btn-outline-danger",
                                          "aria-labelledby": _ctx.$id('action'),
                                          title: _ctx.$t('general.delete'),
                                          onClick: ($event: any) => (_ctx.deleteRealm(realm, index)),
                                          disabled: !this.mayEditRealms
                                        }, _hoisted_97, 8, _hoisted_95)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 2))
                            }), 128)),
                            _createElementVNode("tr", _hoisted_98, [
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["form-control", !this.initialiezd?'hidden':'']),
                                  "aria-labelledby": _ctx.$id('code'),
                                  id: _ctx.$id('temporaryRealmCode'),
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.temporaryRealmCode) = $event)),
                                  ref: "temporaryRealmCodeRef",
                                  disabled: !this.initialiezd
                                }, null, 10, _hoisted_99), [
                                  [_vModelText, _ctx.temporaryRealmCode]
                                ]),
                                _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.$t('project.edit.realms.missingName')), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["form-control", !this.initialiezd?'hidden':'']),
                                  "aria-labelledby": _ctx.$id('name'),
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.temporaryRealmName) = $event)),
                                  id: _ctx.$id('temporaryRealmName'),
                                  ref: "temporaryRealmNameRef",
                                  disabled: _ctx.info === _ctx.loadingPlaceholder,
                                  required: ""
                                }, null, 10, _hoisted_101), [
                                  [_vModelText, _ctx.temporaryRealmName]
                                ]),
                                _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.$t('project.edit.realms.missingName')), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["form-control", !this.initialiezd?'hidden':'']),
                                  "aria-labelledby": _ctx.$id('description'),
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.temporaryRealmDescription) = $event)),
                                  id: _ctx.$id('temporaryRealmDescription'),
                                  ref: "temporaryRealmDescriptionRef",
                                  disabled: _ctx.info === _ctx.loadingPlaceholder
                                }, null, 10, _hoisted_103), [
                                  [_vModelText, _ctx.temporaryRealmDescription]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["form-control", !this.initialiezd?'hidden':'']),
                                  "aria-labelledby": _ctx.$id('labelText'),
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.temporaryRealmLabelText) = $event)),
                                  id: _ctx.$id('temporaryRealmLabelText'),
                                  ref: "temporaryRealmLabelTextRef",
                                  disabled: _ctx.info === _ctx.loadingPlaceholder
                                }, null, 10, _hoisted_104), [
                                  [_vModelText, _ctx.temporaryRealmLabelText]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "color",
                                  class: _normalizeClass(["form-control", !this.initialiezd?'hidden':'']),
                                  "aria-labelledby": _ctx.$id('redliningColor'),
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.temporaryRealmRedliningColor) = $event)),
                                  id: _ctx.$id('temporaryRealmRedliningColor'),
                                  ref: "temporaryRealmRedliningColorRef",
                                  disabled: _ctx.info === _ctx.loadingPlaceholder
                                }, null, 10, _hoisted_105), [
                                  [_vModelText, _ctx.temporaryRealmRedliningColor]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  class: _normalizeClass(["form-check-input", !this.initialiezd?'hidden':'']),
                                  "aria-labelledby": _ctx.$id('signatureOnLabel'),
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.temporarySignatureOnLabel) = $event)),
                                  id: _ctx.$id('temporaryRealmSignatureOnLabel'),
                                  ref: "temporaryRealmSignatureOnLabelRef",
                                  disabled: _ctx.info === _ctx.loadingPlaceholder
                                }, null, 10, _hoisted_106), [
                                  [_vModelCheckbox, _ctx.temporarySignatureOnLabel]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["form-control", !this.initialiezd?'hidden':'']),
                                  "aria-labelledby": _ctx.$id('labelTextFieldSeq'),
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.temporaryRealmLabelTextFieldSeq) = $event)),
                                  id: _ctx.$id('temporaryRealmLabelTextFieldSeq'),
                                  ref: "temporaryRealmLabelTextFieldSeqRef",
                                  disabled: _ctx.info === _ctx.loadingPlaceholder
                                }, null, 10, _hoisted_107), [
                                  [_vModelText, _ctx.temporaryRealmLabelTextFieldSeq]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                (this.mayEditRealms)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-sm btn-primary",
                                        title: _ctx.$t('general.add'),
                                        "aria-label": _ctx.$t('general.add'),
                                        id: _ctx.$id('temporaryRealmSubmit'),
                                        disabled: !this.initialized || (this.realms && this.realms.length == 0),
                                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.addRealm()))
                                      }, _hoisted_111, 8, _hoisted_109)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 512)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ], 8, _hoisted_72),
          _createElementVNode("div", {
            class: "tab-pane",
            id: _ctx.$id('objectPlannerDefinitions'),
            role: "tabpanel",
            "aria-labelledby": _ctx.$id('object-planner-definitions-tab')
          }, [
            _createVNode(_component_FormGridLocal, {
              columns: 2,
              labelWidth: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormGridColumn, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_FormGridMember, null, {
                      label: _withCtx(({ controlId, class: clazz }) => [
                        _createElementVNode("label", {
                          class: _normalizeClass(`col-form-label text-md-end mt-3 ${clazz}`),
                          for: controlId
                        }, _toDisplayString(_ctx.$t('project.edit.objectPlannerDefinitions.positionsCaption')), 11, _hoisted_113)
                      ]),
                      control: _withCtx(({ id }) => [
                        (!this.hasObjectPlannerDefinition)
                          ? (_openBlock(), _createBlock(_component_Select, {
                              key: 0,
                              class: "form-control mt-3",
                              mode: "flex",
                              options: this.objectPlannerDefinitionOptions,
                              modelValue: this.objectPlannerDefinitionTemplateId,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((this.objectPlannerDefinitionTemplateId) = $event)),
                              style: {"width":"30em"}
                            }, null, 8, ["options", "modelValue"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: id,
                                class: "form-control mt-3",
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((this.objectPlannerDefinitionName) = $event)),
                                disabled: true
                              }, null, 8, _hoisted_114), [
                                [_vModelText, this.objectPlannerDefinitionName]
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-primary",
                                "data-bs-toggle": "tooltip",
                                title: _ctx.$t('project.edit.objectPlannerDefinitions.addToolTip'),
                                onClick: _cache[33] || (_cache[33] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addPosition && _ctx.addPosition(...args)), ["prevent"]))
                              }, _hoisted_117, 8, _hoisted_115)
                            ], 64))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_FormGridColumn, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_FormGridMember)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ObjectPlannerPositionDefinitionListWidget, {
              items: this.positionInfos,
              roleTypes: this.roleTypes,
              onAddPosition: this.addPosition,
              onDeletePosition: this.deletePosition
            }, null, 8, ["items", "roleTypes", "onAddPosition", "onDeletePosition"]),
            (this.positionInfos != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_ctx.$t('project.edit.objectPlannerDefinitions.countLabel', this.positionInfos.length)), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_112)
        ]),
        _createElementVNode("div", _hoisted_119, [
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.saveProject && _ctx.saveProject(...args))),
              class: "btn btn-primary",
              disabled: !this.initialized || !this.ok || this.isCodeDuplicate
            }, _toDisplayString(_ctx.$t("general.save")), 9, _hoisted_121),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary m-1",
              onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, _toDisplayString(_ctx.$t('general.cancel')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["transformer"]))
}